module.exports = __webpack_public_path__ + "img/santoto.479a559d.png";